import React from 'react';
//import logo from './logo.svg';
//import './App.css';
import { withScriptjs } from "react-google-maps";



import  Map from './Mapagendamap';



function App2(props) {
    var destino= props.localdestino;
    var saida=props.localsaida;
    var listaparadasida=props.listaparadasida;
    var listaparadasvolta=props.listaparadasvolta;
    const MapLoader = withScriptjs(Map);
   
    function setakm(prop){
      //setalistageovolta (currentArray => [...currentArray, props]);
      console.log('resultado kilometragem',prop);
      props.setakm(prop);
     
    }

    
    function setatemporetorno(prop){
      props.setatemporetorno(prop);
      //alert(prop);
 
     }
      
      
    

    
    
    

 // const MapLoader = withScriptjs(Map);
  
  console.log('destino', props.localdestino);
  console.log('saida', props.localsaida);
  console.log('paradas volta', props.listaparadasvolta);
  console.log('paradas ida', props.listaparadasida);
  console.log('paradas ida', props.listaparadasida);
  
  
  return (
 //console.log("aqui geocode")
<div className="App">
<MapLoader destino={destino} setakm={setakm} setatemporetorno={setatemporetorno} saida={saida} listaparadasida={listaparadasida} listaparadasvolta={listaparadasvolta}
      googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyA0RbxlQeRjG7ZPfUSz1e8KV4oWzqm8Ye8"
      loadingElement={<div id ='01' style={{ height: `50%` }} />}
  />
    
</div>

  );
}

export default App2;